<template>
  <footer class="footer">
    <div class="container" :class="{'footer-rwd': this.$route.name === 'CourseLesson'}">
      <div class="row">
        <div class="col-12">
          <div class="footer-info">
            <span>客服電話: (02)2660-0608 分機207</span> |
            <span>客服時間: 週一至週五: 09:00~18:00</span> |
            <span>客服信箱: mary_wang@liveabc.com</span>
          </div>
          Copyright©Hebron Soft Limited. All Rights Reserved.
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  data () {
    return {

    }
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../assets/styles/color.scss";
@import "../assets/styles/custom.scss";
  .footer {
    padding: calc(4vh - 12px);
    background-color: black;
    min-height: 8vh;
    color: $white-color;
    position: relative;
    text-align: center;
  }
</style>
